import styled from 'styled-components';

export const CommunicationNoteFormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
